import { DaDataParty, DaDataSuggestion } from '@app/models/daData';

const uniqueByInn = (suggestions: DaDataSuggestion<DaDataParty>[]) =>
  suggestions.filter((item, index) => suggestions.findIndex((other) => other.data.inn === item.data.inn) === index);

export const getPartyOptions = (suggestions: DaDataSuggestion<DaDataParty>[]) =>
  uniqueByInn(suggestions).map((suggestion) => ({
    value: suggestion.data.inn,
    label: suggestion.data.inn,
    suggestion,
  }));
